import { faSpinner } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

type GeologyRehandleTableFooterProps = {
  totalLoads?: number
  isLoading: boolean
}

const GeologyRehandleTableFooter: React.FC<GeologyRehandleTableFooterProps> = ({
  totalLoads,
  isLoading
}) => {
  return (
    <div className="bg-theme-surface-2 border border-theme-table-border border-t-2 border-t-theme-table-heading-border flex justify-end items-center p-2 mb-4 fade-up shadow">
      <div className="container mx-auto">
        <div className="flex items-center justify-end">
          <span className="p-4 text-2xl text-theme-text translate-y-1 transition ease-out">Total Loads:</span>
          <span className="p-3 w-24 flex justify-center align-center font-bold bg-theme-warning rounded relative">
            <FontAwesomeIcon icon={faSpinner} spin
              className={`text-5xl text-theme-text transition ease-out opacity-${isLoading ? 100 : 0}`} />
            <span
              className={`text-4xl absolute top-1/2 transform -translate-y-[50%] transition ease-out opacity-${isLoading ? '0' : '100'}`}>
              {totalLoads?.toLocaleString('en-US')}
            </span>
          </span>
        </div>
      </div>
    </div>
  )
}

export default GeologyRehandleTableFooter